export const REGIONS = {
    US: 'US',
    EU: 'EU',
    UK: 'UK',
    CA: 'CA',
    WORLD: 'WORLD',
};
export const REGION_DISPLAY_NAMES = {
    US: '🇺🇸 United States',
    EU: '🇪🇺 European Union',
    UK: '🇬🇧 United Kingdom',
    CA: '🇨🇦 Canada',
    WORLD: '🌍 Global',
};
export function isValidRegion(value) {
    return (value === REGIONS.US ||
        value === REGIONS.EU ||
        value === REGIONS.UK ||
        value === REGIONS.CA ||
        value === REGIONS.WORLD);
}
//# sourceMappingURL=region.js.map